import axios from "axios";
import { baseUrl } from "../Base_url";
export const getAllClassbyTeacher = async (token) => {
    try {
      const res = await axios.get(
        `${baseUrl}/teacher/teacher/sclass/all`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return { error: false, res: res };
    } catch (e) {
      const err = { error: true, data: e?.response?.data?.data };
      return err;
    }
  };
export const createNewLaunchTrek = async (data, token) => {
  try {
    const res = await axios.post(`${baseUrl}/teacher/launchtrek/createLaunchTrek`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return { error: false, res: res };
  } catch (e) {
   //console.log"launch e", e);
    const err = { error: true, data: e?.response?.data?.data };
    return err;
  }
};
export const getLaunchTrekData = async (token,page,limit,orderBy,order) => {
  try {
    const res = await axios.get(`${baseUrl}/teacher/launchtrek/getLauchtrekFiles`, {
      params: { page: page, limit:limit,orderBy:orderBy,order:order },
      headers: { Authorization: `Bearer ${token}` },
    });
    return { error: false, res: res };
  } catch (e) {
   //console.log"graph  e", e);
    return e;
  }
};
export const getFileDetails = async (id, token) => {
  try {
    const res = await axios.get(`${baseUrl}/teacher/launchtrek/getLauchtrekFilesById`, {
      params: { id: id },
      headers: { Authorization: `Bearer ${token}` },
    });
    return { error: false, res: res };
  } catch (e) {
   //console.log"getfile  e", e);
    return e;
  }
};
export const getGraphDetails = async (id, token) => {
  try {
    const res = await axios.get(`${baseUrl}/teacher/launchtrek/getGraphByfileId`, {
      params: { id: id },
      headers: { Authorization: `Bearer ${token}` },
    });
    return { error: false, res: res };
  } catch (e) {
   //console.log"getfile  e", e);
    return e;
  }
};
export const updateLaunchtrekFile = async (id, data, token) => {
  try {
   
    const res = await axios.patch(`${baseUrl}/teacher/launchtrek/editFileData`, data, {
      params: { id: id },
      headers: { Authorization: `Bearer ${token}` },
    });
  
    return { error: false, res: res };
  } catch (e) {
    const err = { error: true, data: e?.response?.data?.data };
    return err;
  }
};

export const deleteLaunchTrekFile = async (id, token) => {
  try {
    const res = await axios.delete(`${baseUrl}/teacher/launchtrek/deleteLaunchFiles`, {
      params: { id: id },
      headers: { Authorization: `Bearer ${token}` },
    });
    return { error: false, res: res };
  } catch (e) {
    const err = { error: true, data: e?.response?.data?.data };
    return err;
  }
};
 